module.exports = __webpack_public_path__ + "img/MFT白皮书_34.24ae6ffa.jpg";